<template>
  <div>
    <Card>
      <List item-layout="vertical" :loading="loading">
        <ListItem v-for="item in data" :key="item.site_id">
          <ListItemMeta>
            <span slot="title">
              <span>站点：</span>
              <a slot="title" v-on:click="$router.push({name: 'baiduSiteDetail', params: {site_id: item.site_id}, query: {domain: item.domain}})" style="color: #2d8cf0">{{ item.domain }}</a>
            </span>
          </ListItemMeta>
          <span>
            <Tag color="primary">今日流量</Tag>
            <Divider type="vertical"/>
            <span>浏览量(PV)：<b>{{ item.pv }}</b></span>
            <Divider type="vertical"/>
            <span>访客数(UV)：<b>{{ item.uv }}</b></span>
            <Divider type="vertical"/>
            <span>IP数：<b>{{ item.ip_count }}</b></span>
            <Divider type="vertical"/>
            <span>跳出率：<b>{{ item.bounce_ratio }}%</b></span>
            <Divider type="vertical"/>
            <span>平均访问时长：<b>{{ formatSeconds(item.avg_visit_time) }}</b></span>
          </span>
        </ListItem>
      </List>
    </Card>
  </div>
</template>

<script>
import { getAnalyseSiteList } from '@/api/opscenter'

export default {
  name: 'list',
  data () {
    return {
      loading: false,
      data: []
    }
  },
  created: function () {
    this.getTableData()
  },
  methods: {
    getTableData () {
      this.loading = true
      getAnalyseSiteList().then(res => {
        this.data = res.data
        this.loading = false
      }).catch(res => {
        this.loading = false
        console.error(res.response)
      })
    },
    formatSeconds (value) {
      var theTime = parseInt(value)
      var middle = 0
      var hour = 0
      if (theTime > 60) {
        middle = parseInt(theTime / 60)
        theTime = parseInt(theTime % 60)
        if (middle > 60) {
          hour = parseInt(middle / 60)
          middle = parseInt(middle % 60)
        }
      }
      var result = '' + parseInt(theTime)
      if (middle > 0) {
        result = '' + parseInt(middle) + ':' + result
      }
      if (hour > 0) {
        result = '' + parseInt(hour) + ':' + result
      }
      return result
    }
  }
}
</script>

<style scoped>

</style>
